export const IconNames = {
    'affiliate': 'affiliate',
    'alert': 'alert',
    'arrow-down-right': 'arrow-down-right',
    'arrow-up-right': 'arrow-up-right',
    'avatar': 'avatar',
    'block': 'block',
    'cancel': 'cancel',
    'close': 'close',
    'close-tag': 'close-tag',
    'cms': 'cms',
    'code': 'code',
    'collapse': 'collapse',
    'collapse-all': 'collapse-all',
    'communication': 'communication',
    'companies': 'companies',
    'copy': 'copy',
    'currency': 'currency',
    'dashboard': 'dashboard',
    'date': 'date',
    'decline': 'decline',
    'default': 'default',
    'delete': 'delete',
    'desktop': 'desktop',
    'deposit': 'deposit',
    'direct-link': 'direct-link',
    'disable': 'disable',
    'down': 'down',
    'down-small': 'down-small',
    'download': 'download',
    'edit': 'edit',
    'ellipsis': 'ellipsis',
    'empty': 'empty',
    'enable': 'enable',
    'expand': 'expand',
    'expand-all': 'expand-all',
    'eye': 'eye',
    'file': 'file',
    'filter': 'filter',
    'globe': 'globe',
    'grid': 'grid',
    'home': 'home',
    'info': 'info',
    'languages': 'languages',
    'left': 'left',
    'lock': 'lock',
    'loginAsAffiliate': 'loginAsAffiliate',
    'logout': 'logout',
    'mediatools': 'mediatools',
    'menu': 'menu',
    'mobile': 'mobile',
    'more': 'more',
    'notification': 'notification',
    'ok': 'ok',
    'pallet': 'pallet',
    'password': 'password',
    'pay': 'pay',
    'payments': 'payments',
    'permission': 'permission',
    'picture': 'picture',
    'player': 'player',
    'plus': 'plus',
    'pointing-arrow': 'pointing-arrow',
    'profile': 'profile',
    'publish': 'publish',
    'postback': 'postback',
    'regex': 'regex',
    'reject': 'reject',
    'reload': 'reload',
    'rename': 'rename',
    'report': 'report',
    'reset': 'reset',
    'right': 'right',
    'search': 'search',
    'select-down': 'select-down',
    'send': 'send',
    'settings': 'settings',
    'sort-down': 'sort-down',
    'sort-up': 'sort-up',
    'speaker': 'speaker',
    'success': 'success',
    'success-fill': 'success-fill',
    'tablet': 'tablet',
    'test': 'test',
    'time': 'time',
    'transfer': 'transfer',
    'translations': 'translations',
    'trash': 'trash',
    'unpublish': 'unpublish',
    'up': 'up',
    'upload': 'upload',
    'user-avatar': 'user-avatar',
    'userlogs': 'userlogs',
    'users': 'users',
    'wallet': 'wallet',
    'warning': 'warning',
    'playerCount': 'playerCount',
    'send-dashed': 'send-dashed',
    'marketingSend': 'marketingSend',
    'visible': 'visible',
    'email': 'email',
    'email-read': 'email-read',
    'guide': 'guide',
    'not-found': 'not-found',
    'commission': 'commission',
    'ticket': 'ticket',
    'resend': 'resend',
    'bell': 'bell',
    'mute': 'mute',
    'unmute': 'unmute',
    'ntf-affiliate': 'ntf-affiliate',
    'ntf-campaign': 'ntf-campaign',
    'ntf-comission': 'ntf-comission',
    'ntf-invoice': 'ntf-invoice',
    'ntf-project': 'ntf-project',
    'bin': 'bin',
    'read': 'read',
    'error-alert': 'error-alert',
    'refresh': 'refresh',
    'time-zone': 'time-zone',
};